import React from "react";
import { Section, Field, TextIn, Choice } from "./obUi";

export const FirmSection = ({ a, set, ro }) => {
  const p = { a, set, ro };
  return (
    <Section n={1} title="Your firm & main contact" testId="ob-section-firm"
             hint="The company name is what people see on your landing pages and thank-you page. Your contact details stay private and are never shown on your pages.">
      <Field label="Company / firm name" required hint="As it should appear on your pages">
        <TextIn {...p} k="firm_name" testId="ob-firm-name" placeholder="e.g. Smith Injury Law" />
      </Field>
      <Field label="Legal business name" hint="For the fine print, if different">
        <TextIn {...p} k="legal_name" testId="ob-legal-name" placeholder="e.g. Smith Law Group, PLLC" />
      </Field>
      <Field label="Contact person" required hint="Private. Never shown on your pages">
        <TextIn {...p} k="contact_name" testId="ob-contact-name" placeholder="Full name" />
      </Field>
      <Field label="Contact email" required hint="Main contact for account emails and your login">
        <TextIn {...p} k="contact_email" type="email" testId="ob-contact-email" placeholder="name@firm.com" />
      </Field>
      <Field label="Contact phone">
        <TextIn {...p} k="contact_phone" type="tel" testId="ob-contact-phone" placeholder="(555) 123-4567" />
      </Field>
      <Field label="Do you want a login to see your leads?">
        <div className="grid grid-cols-2 gap-2">
          <Choice ro={ro} on={a.wants_login} onClick={() => set("wants_login", true)} testId="ob-login-yes">Yes, send me a login</Choice>
          <Choice ro={ro} on={!a.wants_login} onClick={() => set("wants_login", false)} testId="ob-login-no">No login needed</Choice>
        </div>
      </Field>
    </Section>
  );
};
